import { ModulePackFE_EncounterSnapshot } from '../_entity.js';
import { ModulePackFE_EncounterSimulation } from '../_entity/encounter-simulation/module-pack.js';
import { ModulePackFE_SimulationDemoEvent } from '../_entity/simulation-demo-events/module-pack.js';
import { ModuleFE_EHREmulator } from './ModuleFE_EHREmulator.js';
export const ModulePackFE_EhrEmulator = [
    ...ModulePackFE_EncounterSnapshot,
    ...ModulePackFE_EncounterSimulation,
    // ...ModulePackFE_EncounterData,
    // ...ModulePackFE_EncounterEvent,
    ...ModulePackFE_SimulationDemoEvent,
    ModuleFE_EHREmulator,
];
//# sourceMappingURL=module-pack.js.map